import React from 'react';
import type PlanSettingsInfoType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/auto-scheduler/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - auto-scheduler page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsAutoScheduler = lazyForPaint<typeof PlanSettingsInfoType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-auto-scheduler", jiraSpaEntry: "async-plan-settings-auto-scheduler" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/auto-scheduler'
			),
		),
	{ ssr: false },
);

const AsyncPlanSettingsAutoScheduler = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsAutoScheduler}
		pageId="plan-settings-auto-scheduler"
		shouldShowSpinner
	/>
);

export default AsyncPlanSettingsAutoScheduler;
